import { createFileRoute } from "@tanstack/react-router";

import { Download } from "@/features/my/download";

export const Route = createFileRoute("/(member)/(protected)/my/download")({
  component: Download,
});
